import '../design-system/components/image/overlay/imageOverlay.css';
import '../design-system/components/image/image.css';
import '../design-system/styles/reset.css';
import '../design-system/styles/grid.css';
import '../design-system/styles/typography.css';
import '../design-system/styles/animation.css';
import '../design-system/styles/variables/colors.css';
import '../design-system/styles/variables/zIndex.css';
import '../design-system/styles/variables/gradients.css';
import '../design-system/styles/variables/spaces.css';
import '../design-system/styles/variables/typography.css';
import '../design-system/styles/variables/cover.css';
import '../design-system/styles/variables/components.css';
import '../styles/globals.css';
import '../styles/layout.css';
